import { fromJS } from 'immutable';
import _ from 'lodash';
import { createAsyncAction } from '../utils';

const initialState = fromJS({
    loading: false,
    error: null,
    projects: [],
    groups: []
});

import { environmentTypesActions } from './environment-types';

export const getSelectedProjectsAndGroups = createAsyncAction('GET_SELECTED_PROJECTS_AND_GROUPS');
export const setSelectedProjectsAndGroups = createAsyncAction('SET_SELECTED_PROJECTS_AND_GROUPS');

export default function selectedReducer(state = initialState, action) {
    switch (action.type) {
        case getSelectedProjectsAndGroups.REQUEST:
            return fromJS({ ...state.toJS(), loading: true, error: null });
        case getSelectedProjectsAndGroups.SUCCESS:
            return fromJS({
                ...state.toJS(),
                loading: false,
                projects: action.payload.projects,
                groups: action.payload.groups
            });
        case getSelectedProjectsAndGroups.FAIL:
            return fromJS({ ...state.toJS(), loading: false, error: action.payload });
        case setSelectedProjectsAndGroups.REQUEST:
            return fromJS({ ...state.toJS(), loading: true, error: null });
        case setSelectedProjectsAndGroups.SUCCESS:
            return fromJS({
                ...state.toJS(),
                loading: false,
                projects: action.payload.projects,
                groups: action.payload.groups
            });
        case setSelectedProjectsAndGroups.FAIL:
            return fromJS({ ...state.toJS(), loading: false, error: action.payload });
        default:
            return state;
    }
}

export function selectedActions($http, api) {
    'ngInject';
    function loadSelected() {
        return dispatch => {
            dispatch({ type: getSelectedProjectsAndGroups.REQUEST });
            return $http.get(`${api.restServiceUrlDB}projects/latest`).then(
                response => {
                    dispatch({
                        type: getSelectedProjectsAndGroups.SUCCESS,
                        payload: {
                            projects: response.data.projectIds,
                            groups: response.data.groupIds
                        }
                    });
                },
                error => {
                    dispatch({ type: getSelectedProjectsAndGroups.FAIL, error: true, payload: error.data });
                }
            );
        };
    }

    function select({ projects, groups }) {
        return (dispatch, getState) => {
            const state = getState();
            const currentProjects = state.newdashboard.selected.get('projects').toJS();
            const currentGroups = state.newdashboard.selected.get('groups').toJS();
            environmentTypesActions($http, api).loadEnvironmentTypes({ projectIds:projects, groupIds:groups })(dispatch);
            if (_.isEqual(projects.sort(), currentProjects.sort()) && _.isEqual(groups.sort(), currentGroups.sort())) {
                return;
            }

            dispatch({ type: setSelectedProjectsAndGroups.REQUEST });
            return $http.put(`${api.restServiceUrlDB}projects/latest`, { projectIds: projects, groupIds: groups }).then(
                response => {
                    dispatch({ type: setSelectedProjectsAndGroups.SUCCESS, payload: { projects, groups } });
                },
                error => {
                    dispatch({ type: setSelectedProjectsAndGroups.FAIL, error: true, payload: error.data });
                }
            );
        };
    }

    return { loadSelected, select };
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/selected.reducer.js